module.exports = __webpack_public_path__ + "static/img/delete.97cf915c.png";